import { api } from "../axios/api";

const BASE_URL = "/feature-flags/cash-movements";

export const checkCashMovementsStatus = async () => {
  const response = await api.get(`${BASE_URL}/status`);
  return response.data;
};

export const getEntitiesWithCashMovements = async (params = {}) => {
  const { search = "", page = 1, limit = 10 } = params;
  const response = await api.get(`${BASE_URL}/entities`, {
    params: { search, page, limit },
  });
  return response.data;
};

export const toggleCompanyCashMovements = async (companyId, enabled) => {
  const response = await api.patch(`${BASE_URL}/companies/${companyId}`, {
    enabled,
  });
  return response.data;
};

export const toggleIntermediaireCashMovements = async (
  intermediaireId,
  enabled,
) => {
  const response = await api.patch(
    `${BASE_URL}/intermediaires/${intermediaireId}`,
    { enabled },
  );
  return response.data;
};
